<template>
    <div class="w-full h-36 border-solid border border-gray-type-9 rounded-lg">
        <div class="flex items-center justify-between p-3 border-b border-gray-type-9 ">
            <div>
                <button @click="editor.chain().focus().toggleBold().run()">
                    <img src="@/assets/icons/tiptap/bold.svg" alt="">
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().toggleItalic().run()">
                    <img src="@/assets/icons/tiptap/italic.svg" alt="">
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().toggleUnderline().run()">
                    <img src="@/assets/icons/tiptap/underline.svg" alt="">
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().setTextAlign('left').run()" >
                    <img src="@/assets/icons/tiptap/alignLeft.svg" alt="">
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().setTextAlign('center').run()" >
                    <img src="@/assets/icons/tiptap/alignCenter.svg" alt="">
                </button>
            </div>
            <div class="flex justify-evenly">
                <div class="mr-2">
                    <button @click="editor.chain().focus().undo().run()">
                        <img src="@/assets/icons/tiptap/undo.svg" alt="">
                    </button>
                </div>
                <div>
                    <button @click="editor.chain().focus().redo().run()">
                        <img src="@/assets/icons/tiptap/redo.svg" alt="">
                    </button>
                </div>
            </div>
        </div>
        <editor-content :editor="editor" class="h-full"/>
    </div>
  
</template>

<script>
import Document from '@tiptap/extension-document'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'
import Heading from '@tiptap/extension-heading'
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'

export default {
  components: {
    EditorContent,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit,
        Document,
        Paragraph,
        Text,
        OrderedList,
        ListItem,
        Underline,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        Heading.configure({
          levels: [1, 2, 3],
        }),
      ],
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      },
    })
  },
  methods:{
     isActiveFixed(mark) {
      if (this.editor != null) {
        return this.editor.isActive(mark);
      }

      return false;
    }
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
/* Basic editor styles */
.ProseMirror {
  height: 65%;
  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }
}
</style>